import {UpdateStatusTypes, apiLocker} from '../../../../stores/Form/API_Locker';

export const changeLockerStatus = (
    session: string,
    status: UpdateStatusTypes,
    isHTMLForm: boolean = false
) => {
    const data = apiLocker.getDataBySession(session);

    if (data) {
        data.toggleStatus(status, isHTMLForm);
    }
};
